export default "__VITE_ASSET__$NSR3e$f__"